const classes = [
  {
    class: "Introduction to Organic Gardening",
    desc: "Learn the basics of growing organic vegetables and fruits in your backyard.",
    image: "https://images.unsplash.com/photo-1656740839066-db82019b292b?q=80&w=1674&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    class: "Herb Cultivation and Medicinal Plants",
    desc: "Discover how to cultivate herbs for culinary use and their medicinal properties.",
    image: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    class: "Sustainable Farming Techniques",
    desc: "Explore sustainable farming methods that promote environmental conservation.",
    image: "https://images.unsplash.com/photo-1523810192022-5a0fb9aa7ff8?q=80&w=1734&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    class: "Urban Gardening in Small Spaces",
    desc: "Learn how to create a thriving garden in limited urban spaces like balconies and rooftops.",
    image: "https://images.unsplash.com/photo-1492114011589-509c6e695d8e?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    class: "GoGreen Farming Initiative",
    desc: "Join our GoGreen campaign and learn sustainable farming practices for a healthier planet.",
    image: "https://images.unsplash.com/photo-1460533893735-45cea2212645?q=80&w=1828&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    class: "Seed Saving Workshop",
    desc: "Discover the art of seed saving and preserving biodiversity in your garden.",
    image: "https://plus.unsplash.com/premium_photo-1679366696626-f4ca046868be?q=80&w=1742&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  }
];

export default classes;
